import { render } from "./Precision.vue?vue&type=template&id=2ce10bf1"
import script from "./Precision.vue?vue&type=script&lang=ts"
export * from "./Precision.vue?vue&type=script&lang=ts"
script.render = render

export default script